import { useEffect, useMemo } from "react";

/**
 * SceneThumb — efficient object-URL-backed preview for a File object.
 * Uses useMemo for the URL so it doesn't churn on re-renders, plus an
 * effect that revokes the URL on unmount.
 */
export default function SceneThumb({ file }) {
  const url = useMemo(() => (file ? URL.createObjectURL(file) : null), [file]);
  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);
  if (!url) return null;
  return <img src={url} alt={file.name} className="absolute inset-0 w-full h-full object-cover" />;
}
